// Style for layout wrapper
const Style = (theme) => ({
  wrapper: {
    display: 'flex',
    minHeight: '100vh',
    maxWidth: 'none',
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
  },
});

export default Style;
